<div class="py-4">
  <span class="text-xs text-gray-500">
    © 2026 CO2CERO SAS. Todos los derechos reservados
  </span>
</div>